export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      skills: 'Skills',
      projects: 'Projects',
      certifications: 'Certifications',
      awards: 'Awards',
      education: 'Education',
      contact: 'Contact',
      hireMe: 'Hire Me',
    },
    hero: {
      greeting: 'hello world /',
      im: "I'm",
      roles: ['Database Administrator', 'Full Stack Developer', 'Computer Vision Engineer'],
      desc: {
        p1: 'Database Administrator at',
        company: 'Telkomsigma',
        p2: 'with a strong foundation in',
        ai: 'AI & Computer Vision',
        p3: '. Building reliable, scalable solutions from',
        db: 'database systems',
        p4: 'to',
        dl: 'deep learning models',
      },
      emailMe: 'Email Me',
      downloadCV: 'Download CV',
      badge: 'DBA @Telkomsigma',
    },
    about: {
      subtitle: '// get to know me',
      title: 'About',
      titleHighlight: 'Me',
      p1: {
        t1: 'Database Administrator at',
        company: 'Telkomsigma (PT Sigma Cipta Caraka)',
        t2: 'with a strong foundation in',
        ai: 'AI, Computer Vision',
        t3: 'and',
        dl: 'Deep Learning',
        t4: '. I manage and optimize database systems to ensure high availability, performance, and data integrity for enterprise-level operations.',
      },
      p2: 'Previously built hands-on experience in AI/ML — specializing in Computer Vision and real-time object detection. Designed and deployed end-to-end AI pipelines using YOLO, PyTorch, TensorFlow, FastAPI, and Docker with real-world applications in healthcare, transportation, and safety.',
      p3: 'What sets me apart is the intersection of my skills — I understand both the data infrastructure that powers intelligent systems and the AI models that run on top of it.',
      quickInfo: {
        currentRole: 'Current Role',
        currentRoleValue: 'DBA @Telkomsigma',
        databases: 'Databases',
        databasesValue: 'MySQL, PostgreSQL, Oracle',
        education: 'Education',
        educationValue: 'Bachelor of Computer Science- UNISA Yogyakarta',
        location: 'Location',
        locationValue: 'Yogyakarta, Indonesia',
      },
      experienceJourney: 'Experience Journey',
      timeline: [
        {
          year: 'Oct 2025 - Present',
          title: 'Database Administrator',
          companyName: 'Telkomsigma (PT Sigma Cipta Caraka)',
          companyUrl: 'https://www.telkomsigma.co.id/',
          image: '/assets/experience/Logo Telkomsigma.png',
          desc: 'Manage enterprise database systems (MySQL, PostgreSQL, Oracle, MongoDB, SQL Server) ensuring 99.9% uptime. Perform monitoring, backup & recovery, query optimization.',
        },
        {
          year: 'Aug - Sep 2025',
          title: 'IT Programmer & Support',
          companyName: 'RSUD Al-Mulk',
          companyUrl: 'https://www.google.com/search?q=RSUD+Al-Mulk',
          image: '/assets/experience/Rsud AlMulk.jpg',
          desc: 'Developed and maintained hospital information systems (SIMRS) using Java, PHP & MySQL. Provided IT support and database management.',
        },
        {
          year: 'Mar - Jul 2024',
          title: 'Computer Vision Engineer Intern',
          companyName: 'DataIns / PT Global Data Inspirasi',
          companyUrl: 'https://www.datains.id/',
          image: '/assets/experience/datains.jpg',
          desc: 'Built real-time detection pipelines with YOLO for safety monitoring & vehicle detection. Deployed models via FastAPI & Docker.',
        },
        {
          year: 'Aug 2024 - Present',
          title: 'Freelance AI & Software Developer',
          companyName: 'Independent Clients',
          companyUrl: 'https://www.linkedin.com/in/restuagilya/',
          image: 'https://st2.depositphotos.com/3369547/10275/v/450/depositphotos_102759520-stock-illustration-development-and-software-design.jpg',
          desc: 'Creating AI projects: image processing, recognition, real-time detection using PyTorch, TensorFlow, YOLO, Faster R-CNN.',
        },
      ],
    },
    skills: {
      subtitle: '// what I work with',
      title: 'My',
      titleHighlight: 'Skills',
      categories: {
        'Database Administration': 'Database Administration',
        'AI / Machine Learning': 'AI / Machine Learning',
        'Web & App Development': 'Web & App Development',
        'Programming Languages': 'Programming Languages',
        'DevOps & Tools': 'DevOps & Tools',
      },
    },
    projects: {
      subtitle: "// things I've built",
      title: 'My',
      titleHighlight: 'Projects',
      featured: 'Featured',
      viewMore: 'View More on LinkedIn',
      viewDemo: 'Try Apps',
      tryApps: 'Try Apps',
      publication: 'Publication',
      viewDetails: 'View Details',
      viewCode: 'View Code',
      noVideo: 'Video demo coming soon',
      viewLandingPage: 'Landing Page',
      downloadApk: 'Download APK',
      loadMore: 'Load More Projects',
      internalBadge: 'Internal Project',
      privateOnly: 'Private Access Only',
      internalHint: 'This project is private and cannot be opened publicly.',
      previousPreview: 'Previous preview',
      nextPreview: 'Next preview',
      items: {
        artoKu: {
          title: 'ArtoKu - Smart Finance Manager',
          subtitle: 'Personal Product - Flutter x Firebase',
          description:
            'Smart finance manager built from scratch with Flutter, Firebase, Gemini AI, and WAHA WhatsApp API. Includes AI Voice Input, receipt scanning, and ArtoBot automation.',
          longDescription:
            'ArtoKu is a smart personal finance manager developed end-to-end using Flutter, Firebase, Gemini AI, and WAHA WhatsApp API. Key features include AI Voice Input, AI Receipt Scanner, visual analytics, multi-wallet support, PDF & CSV reports, Dark Mode, and ArtoBot (24/7 WhatsApp bot) to log transactions and check reports without opening the app. Tech stack: Flutter, Firebase Auth, Cloud Firestore, Google Gemini AI, fl_chart, PDF generation, local_auth, and Speech-to-Text.',
        },
        artoKuLandingPage: {
          title: 'ArtoKu Landing Page',
          subtitle: 'Product Website - Next.js',
          description:
            'A conversion-focused website for ArtoKu that showcases AI Voice Input, automatic receipt scanning, analytics, ArtoBot WhatsApp, and direct download flow.',
          longDescription:
            'A product landing page created to communicate ArtoKu value clearly from first view to install action. The content structure highlights key capabilities such as AI Voice Input, Gemini-powered receipt scanning, financial analytics, multi-wallet support, PDF/CSV export, and ArtoBot workflows on WhatsApp. It also presents screenshot walkthroughs and clear resource links (download, releases, and documentation) to improve user onboarding and conversion.',
        },
        weaningFood: {
          title: 'Weaning Food Detection System',
          subtitle: 'Higher Education Research Grant',
          description:
            'Developed with YOLOv5, Flask, HTML & CSS Bootstrap. Contributing to reduce stunting rates in Indonesia by detecting weaning food (MP-ASI) ingredients using AI.',
          longDescription:
            'A comprehensive AI-powered system developed with YOLOv5, Flask, HTML & CSS Bootstrap. This project contributes to reducing stunting rates in Indonesia by detecting weaning food (MP-ASI) ingredients using advanced computer vision. The system can identify various food ingredients and provide nutritional information to help parents make informed dietary choices.',
        },
        carsPlateDetection: {
          title: 'Cars & License Plate Detection',
          subtitle: 'PT. Global Data Inspirasi',
          description:
            'Built with YOLOv8 to monitor vehicles entering/exiting university gates. Achieved Precision 98.8%, Recall 96.8%, mAP50 98.9% with OCR integration.',
          longDescription:
            'AI-powered vehicle monitoring system built with YOLOv8 for university gate surveillance. Achieved industry-leading metrics: Precision 98.8%, Recall 96.8%, mAP50 98.9%. Features OCR integration for automatic license plate text extraction and logging.',
        },
        k3SafetyDetection: {
          title: 'K3 Safety Equipment Detection',
          subtitle: 'PT. Global Data Inspirasi',
          description:
            'YOLO-based detection system for workplace safety equipment. Designed for hazardous work environments like mining, construction, and road paving.',
          longDescription:
            'YOLO-based real-time detection system for workplace safety (K3) equipment. Designed for hazardous environments including mining, construction, and road paving operations. Detects helmets, vests, goggles, and other safety gear to ensure compliance.',
        },
        odolDetection: {
          title: 'ODOL Trucks Detection',
          subtitle: 'PT. Global Data Inspirasi',
          description:
            'AI model for detecting Over Dimension Overloading (ODOL) trucks. Can be embedded in ATCS traffic surveillance cameras.',
          longDescription:
            'AI model for detecting Over Dimension Overloading (ODOL) trucks on highways. Designed for integration with ATCS (Area Traffic Control System) surveillance cameras for real-time traffic safety monitoring.',
        },
        ublTesting: {
          title: 'System Testing UBL Apps',
          subtitle: 'Black Box Testing',
          description:
            'Manual testing of UBL Apps Desktop Version using Black Box Testing methodology with comprehensive documentation.',
        },
        medicalRecordsSystem: {
          title: 'Medical Records System',
          subtitle: 'Java & MySQL',
          description:
            'Java GUI application integrated with MySQL implementing CRUD operations for efficient healthcare data management.',
        },
        ecommerceWordpress: {
          title: 'E-Commerce - WordPress',
          subtitle: 'Content Management System',
          description:
            'Simple e-commerce application built with WordPress CMS for practical online store management.',
        },
        ecommerceDesktopDesign: {
          title: 'E-Commerce UI Design (Desktop)',
          subtitle: 'Figma Prototype',
          description:
            'Modern desktop UI/UX design for an e-commerce platform, created as an interactive Figma prototype.',
        },
        ecommerceMobileDesign: {
          title: 'E-Commerce UI Design (Mobile)',
          subtitle: 'Figma Prototype',
          description:
            'Mobile-responsive UI/UX design for an e-commerce platform, created as an interactive Figma prototype.',
        },
        telkomsigmaCmdb: {
          title: 'CMDB (Configuration Management Database)',
          subtitle: 'Telkomsigma - Internal Project (Role: DBA)',
          description:
            'As DBA, I maintained CMDB reliability for configuration item (CI) and asset data, including performance tuning, access control, and data consistency.',
          longDescription:
            'Internal CMDB platform used to centralize configuration items (CI), asset inventories, and service relationship mapping. My role as Database Administrator covered schema governance, indexing strategy, SQL query optimization, backup and recovery procedures, user privilege control, and data quality validation to support incident and change management processes.',
        },
        telkomsigmaWati: {
          title: 'WATI (Work Auto Response Tools Interface)',
          subtitle: 'Telkomsigma - Internal Project (Role: DBA)',
          description:
            'Internal auto-response and monitoring interface. Based on the portal flow, WATI emphasizes automate, monitor, and respond operations in one dashboard.',
          longDescription:
            'WATI is an internal work auto-response platform with a dashboard-oriented flow for automation, monitoring alerts, identifying assets, and taking quick response actions. As DBA, I focused on database availability, transactional integrity, query performance, and backup strategy so automated responses and monitoring records stay reliable for operations teams.',
        },
        telkomsigmaDms: {
          title: 'DMS (Document Management System)',
          subtitle: 'Telkomsigma - Internal Project (Role: DBA)',
          description:
            'Internal DMS with AI-driven document comparison and document Q&A capabilities, supported by secure and high-performance data operations.',
          longDescription:
            'Enterprise Document Management System for storing, indexing, and governing organizational documents. The platform includes AI-assisted document comparison and question-answering workflows on document content. My DBA responsibilities covered metadata schema design, search-related indexing support, SQL tuning, backup and restore readiness, data access control, and audit trail reliability.',
        },
      },
      categories: {
        'All': 'All',
        'AI/ML': 'AI/ML',
        'Web & App': 'Web & App',
        'QA': 'QA',
        'Internal': 'Internal',
      },
    },
    certifications: {
      subtitle: '// continuous learning',
      title: 'Certifications',
      stats: {
        certificates: 'Certificates',
        toefl: 'TOEFL Score',
        institutions: 'Institutions',
      },
      verify: 'Verify Certificate',
      verifyNA: 'Verification not available',
      closePreview: 'Close certificate preview',
      previousImage: 'Previous image',
      nextImage: 'Next image',
      goToImage: 'Go to image',
      categories: {
        'All': 'All',
        'Data & AI': 'Data & AI',
        'IT & Programming': 'IT & Programming',
        'Language': 'Language',
        'Other': 'Other',
      },
    },
    awards: {
      subtitle: '// my achievements',
      title: 'Awards & Honors',
      proofTag: 'Award Proof',
      previewButton: 'View award proof',
      closeProof: 'Close award proof',
      previousProof: 'Previous proof image',
      nextProof: 'Next proof image',
      goToProof: 'Go to proof image',
      items: [
        {
          title: 'Best Academic and Non-Academic Graduate (April 2025 Period)',
          issuer: "Universitas 'Aisyiyah Yogyakarta",
          year: '2026',
          description:
            'Achieved strong academic performance with GPA 3.4/4.0 and non-academic achievements including MTQ championships at university and national levels.',
          highlight: true,
          proofImages: ['/assets/Awards/Sertifikat Prestasi Akademik.jpeg', '/assets/Awards/Sertifikat Prestasi non-Akademik.jpeg'],
        },
        {
          title: '2nd Place National MTQ Competition',
          issuer: 'Universitas Islam Jakarta',
          year: '2021',
          description:
            'Won 2nd place in the national-level Musabaqah Tilawatil Quran (MTQ) competition organized by Universitas Islam Jakarta.',
          proofImages: ['/assets/Awards/Sertifikat Juara 2 MTQ UIJ JPG version.jpg'],
        },
        {
          title: '1st Place University MTQ Competition',
          issuer: "Universitas 'Aisyiyah Yogyakarta",
          year: '2021',
          description:
            'Won 1st place in the university-level Musabaqah Tilawatil Quran (MTQ) competition organized by Universitas Aisyiyah Yogyakarta.',
          proofImages: ['/assets/Awards/Juara 1 - Tartil LPTQ Unisa.jpg'],
        },
        {
          title: '2nd Place Pencak Silat Competition (West Jakarta City Level)',
          issuer: "Universitas 'Aisyiyah Yogyakarta",
          year: '2019',
          description:
            'Won 2nd place for Men Class D in the city-level Pencak Silat competition in West Jakarta.',
          proofImages: ['/assets/Awards/Restu Agil Yuli Arjun-Sertifikat Juara 2 Pencak Silat.jpg'],
        },
      ],
    },
    education: {
      subtitle: '// where I studied',
      title: 'My',
      titleHighlight: 'Education',
      university: "Universitas 'Aisyiyah Yogyakarta",
      universityUrl: 'https://www.unisayogya.ac.id/',
      accreditationLabel: 'Campus Accreditation',
      accreditationValue: 'Excellent (Unggul)',
      degree: 'S1 Teknologi Informasi (Bachelor of Computer Science)',
      stats: [
        { value: '3.91', label: 'GPA / 4.00' },
        { value: '2021', label: 'Start Year' },
        { value: '2025', label: 'Graduated' },
        { value: '7', label: 'Semesters' },
      ],
      activitiesTitle: 'Academic & Campus Activities',
      activities: [
        {
          title: "PhD Research Assistant - UNISA Yogyakarta",
          period: 'Aug - Oct 2024',
          desc: "Assisted doctoral research activities at Universitas 'Aisyiyah Yogyakarta, contributing to data collection, analysis, and academic documentation.",
        },
        {
          title: 'Student Exchange - Kampus Merdeka (Bandar Lampung University)',
          period: 'Sep - Dec 2023',
          desc: 'Participated in Kemdikbud Pertukaran Mahasiswa Merdeka program. Experienced different academic culture and expanded professional network.',
        },
        {
          title: 'Active Organization & Committee Member',
          period: '2020 - 2024',
          desc: 'Participated in various campus organizations, seminars, and technology events throughout the academic years.',
        },
      ],
      works: {
        title: 'Paper Publications & Patents',
        publicationsTitle: 'Paper Publications',
        patentsTitle: 'Patents / Intellectual Property Rights (IPR)',
        previewButton: 'Preview PDF',
        openJournal: 'Open journal link',
        openDocument: 'Check patent',
        patentNumber: 'IPR No',
        patentStatus: 'Status',
        close: 'Close preview',
        previewTag: 'Paper Preview',
        previewUnavailable: 'PDF preview is not available for this link. Please open the journal link directly.',
        publications: [
          {
            title: 'High-Protein Food Ingredient Detection Using the You Only Look Once (YOLO) Model',
            journal: 'Building of Informatics, Technology and Science (BITS) Journal',
            year: '2025',
            authors: 'Restu Agil Yuli Arjun, Esi Putri Silmina.',
            description:
              'Research on AI-based weaning food ingredient detection using computer vision to support faster and more accurate child nutrition interventions.',
            journalUrl: 'https://ejurnal.seminar-id.com/index.php/bits/article/view/6889/3563',
          },
          {
            title: 'Utilization of YOLOv8 to Detect Car License Plates at the Entrance Gate of University XYZ',
            journal: 'Jurnal Sains dan Informatika',
            year: '2025',
            authors: 'Esi Putri Silmina, Restu Agil Yuli Arjun.',
            description:
              'Research on YOLOv8-based vehicle plate detection to improve security and operational efficiency at campus entrance gates.',
            journalUrl: 'https://jsi.politala.ac.id/index.php/JSI/article/view/916/212',
          },
        ],
        patents: [
          {
            title: 'SIMANIS (Complementary Feeding Menu Detection)',
            institution: 'Directorate General of Intellectual Property',
            year: '2024',
            patentNumber: 'EC002024193259',
            status: 'Registered',
            description:
              'AI-based innovation for identifying complementary feeding ingredients to support nutrition monitoring in healthcare services.',
            referenceUrl: 'https://pdki-indonesia.dgip.go.id/detail/e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855',
          },
          {
            title: 'Genetic Algorithm Implementation for Determining Best and Worst Food Menus',
            institution: 'Directorate General of Intellectual Property',
            year: '2023',
            patentNumber: 'EC00202366511',
            status: 'Registered',
            description:
              'Innovation in food menu optimization using genetic algorithms to support decision-making in nutritional planning.',
            referenceUrl: 'https://pdki-indonesia.dgip.go.id/detail/e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855',
          },
          {
            title: 'Medicine Inventory Application',
            institution: 'Directorate General of Intellectual Property',
            year: '2023',
            patentNumber: 'EC00202317030',
            status: 'Registered',
            description:
              'Innovation of an AI-assisted medicine inventory application to improve stock management and drug distribution efficiency in healthcare facilities.',
            referenceUrl: 'https://pdki-indonesia.dgip.go.id/detail/e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855',
          },
        ],
        emptyPublications: 'No publication data yet.',
        emptyPatents: 'No patent data yet.',
      },
    },
    contact: {
      subtitle: "// let's connect",
      title: 'Get In',
      titleHighlight: 'Touch',
      description:
        "Interested working with me? Feel free to reach out. I'm always open to discussing new projects, creative ideas, or opportunities to be part of your vision.",
      email: 'Email',
      phone: 'Phone',
      location: 'Location',
      ctaTitle: "Let's work",
      ctaTitleHighlight: 'together',
      ctaDesc:
        "Whether you need help with database administration, AI/ML projects, or computer vision solutions, I'm ready to collaborate and bring your ideas to life.",
      sendEmail: 'Send an Email',
      downloadCV: 'Download My CV',
      footer: {
        by: 'Restu Agil Yuli Arjun',
        rights: 'All rights reserved.',
      },
    },
  },

  id: {
    nav: {
      home: 'Beranda',
      about: 'Tentang',
      skills: 'Keahlian',
      projects: 'Proyek',
      certifications: 'Sertifikasi',
      awards: 'Penghargaan',
      education: 'Pendidikan',
      contact: 'Kontak',
      hireMe: 'Hubungi Saya',
    },
    hero: {
      greeting: 'hello world /',
      im: 'Saya',
      roles: ['Database Administrator', 'Full Stack Developer', 'Computer Vision Engineer'],
      desc: {
        p1: 'Database Administrator di',
        company: 'Telkomsigma',
        p2: 'dengan fondasi yang kuat dalam',
        ai: 'AI & Computer Vision',
        p3: '. Membangun solusi yang andal dan terukur, dari',
        db: 'sistem database',
        p4: 'hingga',
        dl: 'model deep learning',
      },
      emailMe: 'Email Saya',
      downloadCV: 'Unduh CV',
      badge: 'DBA @Telkomsigma',
    },
    about: {
      subtitle: '// kenali saya',
      title: 'Tentang',
      titleHighlight: 'Saya',
      p1: {
        t1: 'Database Administrator di',
        company: 'Telkomsigma (PT Sigma Cipta Caraka)',
        t2: 'dengan fondasi yang kuat dalam',
        ai: 'AI, Computer Vision',
        t3: 'dan',
        dl: 'Deep Learning',
        t4: '. Saya mengelola dan mengoptimalkan sistem database untuk memastikan ketersediaan tinggi, performa, dan integritas data untuk operasi tingkat enterprise.',
      },
      p2: 'Sebelumnya membangun pengalaman langsung dalam AI/ML — khususnya Computer Vision dan deteksi objek real-time. Merancang dan mengimplementasikan pipeline AI end-to-end menggunakan YOLO, PyTorch, TensorFlow, FastAPI, dan Docker dengan aplikasi nyata di bidang kesehatan, transportasi, dan keselamatan.',
      p3: 'Yang membedakan saya adalah perpotongan keahlian saya — saya memahami baik infrastruktur data yang mendukung sistem cerdas maupun model AI yang berjalan di atasnya.',
      quickInfo: {
        currentRole: 'Posisi Saat Ini',
        currentRoleValue: 'DBA @Telkomsigma',
        databases: 'Database',
        databasesValue: 'MySQL, PostgreSQL, Oracle',
        education: 'Pendidikan',
        educationValue: 'Sarjana Komputer - UNISA Yogyakarta',
        location: 'Lokasi',
        locationValue: 'Yogyakarta, Indonesia',
      },
      experienceJourney: 'Perjalanan Karir',
      timeline: [
        {
          year: 'Okt 2025 - Sekarang',
          title: 'Database Administrator',
          companyName: 'Telkomsigma (PT Sigma Cipta Caraka)',
          companyUrl: 'https://www.telkomsigma.co.id/',
          image: '/assets/experience/Logo Telkomsigma.png',
          desc: 'Mengelola sistem database enterprise (MySQL, PostgreSQL, Oracle, MongoDB, SQL Server) dengan uptime 99.9%. Melakukan monitoring, backup & recovery, optimasi query.',
        },
        {
          year: 'Agt - Sep 2025',
          title: 'IT Programmer & Support',
          companyName: 'RSUD Al-Mulk',
          companyUrl: 'https://www.google.com/search?q=RSUD+Al-Mulk',
          image: '/assets/experience/Rsud AlMulk.jpg',
          desc: 'Mengembangkan dan memelihara sistem informasi rumah sakit (SIMRS) menggunakan Java, PHP & MySQL. Menyediakan dukungan IT dan manajemen database.',
        },
        {
          year: 'Mar - Jul 2024',
          title: 'Magang Computer Vision Engineer',
          companyName: 'DataIns / PT Global Data Inspirasi',
          companyUrl: 'https://www.datains.id/',
          image: '/assets/experience/datains.jpg',
          desc: 'Membangun pipeline deteksi real-time dengan YOLO untuk monitoring keselamatan & deteksi kendaraan. Deploy model via FastAPI & Docker.',
        },
        {
          year: 'Agt 2024 - Sekarang',
          title: 'Freelance AI Developer',
          companyName: 'Klien Independen',
          companyUrl: 'https://www.linkedin.com/in/restuagilya/',
          image: 'https://st2.depositphotos.com/3369547/10275/v/450/depositphotos_102759520-stock-illustration-development-and-software-design.jpg',
          desc: 'Membuat proyek AI: pemrosesan gambar, pengenalan, deteksi real-time menggunakan PyTorch, TensorFlow, YOLO, Faster R-CNN.',
        },
      ],
    },
    skills: {
      subtitle: '// alat yang saya gunakan',
      title: 'Keahlian',
      titleHighlight: 'Saya',
      categories: {
        'Database Administration': 'Administrasi Database',
        'AI / Machine Learning': 'AI / Machine Learning',
        'Web & App Development': 'Pengembangan Web & Aplikasi',
        'Programming Languages': 'Bahasa Pemrograman',
        'DevOps & Tools': 'DevOps & Alat',
      },
    },
    projects: {
      subtitle: '// yang sudah saya buat',
      title: 'Proyek',
      titleHighlight: 'Saya',
      featured: 'Unggulan',
      viewMore: 'Lihat Lebih di LinkedIn',
      viewDemo: 'Coba Aplikasi',
      tryApps: 'Coba Aplikasi',
      publication: 'Publikasi',
      viewDetails: 'Lihat Detail',
      viewCode: 'Lihat Kode',
      noVideo: 'Video demo segera hadir',
      viewLandingPage: 'Landing Page',
      downloadApk: 'Download APK',
      loadMore: 'Load Project Lainnya',
      internalBadge: 'Proyek Internal',
      privateOnly: 'Akses Private',
      internalHint: 'Proyek ini bersifat private dan tidak dapat diakses publik.',
      previousPreview: 'Preview sebelumnya',
      nextPreview: 'Preview berikutnya',
      items: {
        artoKu: {
          title: 'ArtoKu - Smart Finance Manager',
          subtitle: 'Produk Personal - Flutter x Firebase',
          description:
            'Aplikasi manajemen keuangan pintar yang dibangun dari nol dengan Flutter, Firebase, Gemini AI, dan WAHA WhatsApp API. Memiliki Voice Input AI, Scan Struk AI, dan ArtoBot otomatis.',
          longDescription:
            'ArtoKu adalah aplikasi manajemen keuangan personal cerdas yang dikembangkan end-to-end menggunakan Flutter, Firebase, Gemini AI, dan WAHA WhatsApp API. Fitur utama: Voice Input AI, Scan Struk AI, analisis visual, multi dompet, laporan PDF & CSV, Dark Mode, serta ArtoBot (WhatsApp bot 24/7) untuk mencatat transaksi dan cek laporan tanpa membuka aplikasi. Tech stack: Flutter, Firebase Auth, Cloud Firestore, Google Gemini AI, fl_chart, PDF generation, local_auth, dan Speech-to-Text.',
        },
        artoKuLandingPage: {
          title: 'Landing Page ArtoKu',
          subtitle: 'Website Produk - Next.js',
          description:
            'Website konversi untuk ArtoKu yang menampilkan AI Voice Input, scan struk otomatis, analisis keuangan, ArtoBot WhatsApp, dan alur download yang jelas.',
          longDescription:
            'Landing page produk yang dibuat untuk menjelaskan value ArtoKu secara jelas dari tampilan pertama hingga aksi install. Struktur konten menonjolkan fitur utama seperti AI Voice Input, scan struk berbasis Gemini, analisis keuangan, multi dompet, ekspor PDF/CSV, serta alur ArtoBot di WhatsApp. Halaman ini juga menampilkan walkthrough screenshot dan tautan resource yang jelas (download, releases, dan dokumentasi) untuk meningkatkan onboarding dan konversi pengguna.',
        },
        weaningFood: {
          title: 'Sistem Deteksi Makanan Pendamping ASI',
          subtitle: 'Hibah Penelitian Perguruan Tinggi',
          description:
            'Dikembangkan menggunakan YOLOv5, Flask, HTML & CSS Bootstrap. Berkontribusi dalam menurunkan angka stunting di Indonesia melalui deteksi bahan MP-ASI berbasis AI.',
          longDescription:
            'Sistem AI komprehensif yang dikembangkan dengan YOLOv5, Flask, HTML & CSS Bootstrap. Proyek ini berkontribusi menurunkan angka stunting di Indonesia dengan mendeteksi bahan MP-ASI menggunakan computer vision. Sistem mampu mengidentifikasi berbagai bahan makanan dan memberikan informasi gizi untuk membantu orang tua mengambil keputusan nutrisi yang tepat.',
        },
        carsPlateDetection: {
          title: 'Deteksi Mobil & Plat Nomor Kendaraan',
          subtitle: 'PT. Global Data Inspirasi',
          description:
            'Dibangun dengan YOLOv8 untuk memantau kendaraan masuk/keluar gerbang kampus. Mencapai Precision 98.8%, Recall 96.8%, mAP50 98.9% dengan integrasi OCR.',
          longDescription:
            'Sistem pemantauan kendaraan berbasis AI menggunakan YOLOv8 untuk pengawasan gerbang kampus. Mencapai metrik tinggi: Precision 98.8%, Recall 96.8%, mAP50 98.9%. Dilengkapi integrasi OCR untuk ekstraksi teks plat nomor secara otomatis.',
        },
        k3SafetyDetection: {
          title: 'Deteksi Perlengkapan Keselamatan Kerja (K3)',
          subtitle: 'PT. Global Data Inspirasi',
          description:
            'Sistem deteksi berbasis YOLO untuk perlengkapan keselamatan kerja. Dirancang untuk lingkungan berisiko seperti pertambangan, konstruksi, dan pengaspalan jalan.',
          longDescription:
            'Sistem deteksi real-time perlengkapan keselamatan kerja (K3) berbasis YOLO. Dirancang untuk lingkungan berbahaya seperti pertambangan, konstruksi, dan pengaspalan. Mendeteksi helm, rompi, kacamata pelindung, dan perlengkapan lain untuk memastikan kepatuhan.',
        },
        odolDetection: {
          title: 'Deteksi Truk ODOL',
          subtitle: 'PT. Global Data Inspirasi',
          description:
            'Model AI untuk mendeteksi truk Over Dimension Over Loading (ODOL). Dapat diintegrasikan pada kamera pengawasan lalu lintas ATCS.',
          longDescription:
            'Model AI untuk mendeteksi truk ODOL di jalan raya. Dirancang untuk integrasi dengan kamera Area Traffic Control System (ATCS) guna pemantauan keselamatan lalu lintas secara real-time.',
        },
        ublTesting: {
          title: 'Pengujian Sistem UBL Apps',
          subtitle: 'Pengujian Black Box',
          description:
            'Pengujian manual UBL Apps Desktop Version menggunakan metode Black Box Testing dengan dokumentasi pengujian yang komprehensif.',
        },
        medicalRecordsSystem: {
          title: 'Sistem Rekam Medis',
          subtitle: 'Java & MySQL',
          description:
            'Aplikasi GUI Java terintegrasi MySQL dengan implementasi CRUD untuk manajemen data layanan kesehatan secara efisien.',
        },
        ecommerceWordpress: {
          title: 'E-Commerce - WordPress',
          subtitle: 'Content Management System',
          description:
            'Aplikasi e-commerce sederhana berbasis WordPress CMS untuk pengelolaan toko online secara praktis.',
        },
        ecommerceDesktopDesign: {
          title: 'Desain UI E-Commerce (Desktop)',
          subtitle: 'Prototipe Figma',
          description:
            'Desain UI/UX modern untuk platform e-commerce versi desktop yang dibuat sebagai prototipe interaktif di Figma.',
        },
        ecommerceMobileDesign: {
          title: 'Desain UI E-Commerce (Mobile)',
          subtitle: 'Prototipe Figma',
          description:
            'Desain UI/UX responsif mobile untuk platform e-commerce yang dibuat sebagai prototipe interaktif di Figma.',
        },
        telkomsigmaCmdb: {
          title: 'CMDB (Configuration Management Database)',
          subtitle: 'Telkomsigma - Proyek Internal (Role: DBA)',
          description:
            'Sebagai DBA, saya menjaga reliabilitas CMDB untuk data configuration item (CI) dan aset, termasuk tuning performa, kontrol akses, dan konsistensi data.',
          longDescription:
            'Platform CMDB internal yang digunakan untuk sentralisasi configuration item (CI), inventaris aset, serta pemetaan relasi layanan. Peran saya sebagai Database Administrator mencakup tata kelola skema, strategi indexing, optimasi query SQL, prosedur backup dan recovery, kontrol hak akses user, serta validasi kualitas data untuk mendukung proses incident dan change management.',
        },
        telkomsigmaWati: {
          title: 'WATI (Work Auto Response Tools Interface)',
          subtitle: 'Telkomsigma - Proyek Internal (Role: DBA)',
          description:
            'Interface internal untuk auto-response dan monitoring. Dari alur portalnya, WATI berfokus pada automate, monitor, dan respond dalam satu dashboard.',
          longDescription:
            'WATI adalah platform internal work auto-response dengan alur dashboard untuk otomasi, monitoring alert, identifikasi aset, dan pengambilan aksi cepat. Sebagai DBA, saya berfokus pada availability database, integritas transaksi, performa query, dan strategi backup agar data monitoring serta jejak auto-response tetap andal untuk kebutuhan operasional.',
        },
        telkomsigmaDms: {
          title: 'DMS (Document Management System)',
          subtitle: 'Telkomsigma - Proyek Internal (Role: DBA)',
          description:
            'DMS internal dengan fitur AI untuk comparison dokumen dan Q&A terhadap isi dokumen, didukung operasional data yang aman dan cepat.',
          longDescription:
            'Document Management System enterprise untuk penyimpanan, pengindeksan, dan tata kelola dokumen organisasi. Platform ini memiliki workflow AI untuk perbandingan dokumen dan tanya-jawab berdasarkan konten dokumen. Tanggung jawab saya sebagai DBA mencakup desain skema metadata, dukungan indexing untuk pencarian, tuning SQL, kesiapan backup-restore, kontrol akses data, dan reliabilitas audit trail.',
        },
      },
      categories: {
        'All': 'Semua',
        'AI/ML': 'AI/ML',
        'Web & App': 'Web & Aplikasi',
        'QA': 'QA',
        'Internal': 'Internal',
      },
    },
    certifications: {
      subtitle: '// pembelajaran berkelanjutan',
      title: 'Sertifikasi',
      stats: {
        certificates: 'Sertifikat',
        toefl: 'Skor TOEFL',
        institutions: 'Institusi',
      },
      verify: 'Verifikasi Sertifikat',
      verifyNA: 'Verifikasi tidak tersedia',
      closePreview: 'Tutup preview sertifikat',
      previousImage: 'Gambar sebelumnya',
      nextImage: 'Gambar selanjutnya',
      goToImage: 'Lihat gambar ke',
      categories: {
        'All': 'Semua',
        'Data & AI': 'Data & AI',
        'IT & Programming': 'IT & Pemrograman',
        'Language': 'Bahasa',
        'Other': 'Lainnya',
      },
    },
    awards: {
      subtitle: '// pencapaian saya',
      title: 'Penghargaan & Apresiasi',
      proofTag: 'Bukti Penghargaan',
      previewButton: 'Lihat bukti penghargaan',
      closeProof: 'Tutup bukti penghargaan',
      previousProof: 'Bukti sebelumnya',
      nextProof: 'Bukti selanjutnya',
      goToProof: 'Lihat bukti ke',
      items: [
        {
          title: 'Lulusan Terbaik Akademik dan Non-Akademik Periode April 2025',
          issuer: "Universitas 'Aisyiyah Yogyakarta",
          year: '2026',
          description:
            'Meraih prestasi akademik dengan perolehan IPK 3.4/4.0 dan prestasi non-akademik berupa kejuaraan MTQ tingkat universitas dan nasional.',
          highlight: true,
          proofImages: ['/assets/Awards/Sertifikat Prestasi Akademik.jpeg', '/assets/Awards/Sertifikat Prestasi non-Akademik.jpeg'],
        },
        {
          title: 'Juara 2 Lomba MTQ Tingkat Nasional',
          issuer: 'Universitas Islam Jakarta',
          year: '2021',
          description:
            'Mendapatkan juara 2 dalam lomba Musabaqah Tilawatil Quran (MTQ) tingkat nasional yang diadakan oleh Universitas Islam Jakarta.',
          proofImages: ['/assets/Awards/Sertifikat Juara 2 MTQ UIJ JPG version.jpg'],
        },
        {
          title: 'Juara 1 Lomba MTQ Tingkat Universitas',
          issuer: "Universitas 'Aisyiyah Yogyakarta",
          year: '2021',
          description:
            'Meraih juara 1 dalam lomba Musabaqah Tilawatil Quran (MTQ) tingkat universitas yang diadakan oleh Universitas Aisyiyah Yogyakarta.',
          proofImages: ['/assets/Awards/Juara 1 - Tartil LPTQ Unisa.jpg'],
        },
        {
          title: 'Juara 2 Lomba Pencak Silat Tingkat Kota Jakarta Barat',
          issuer: "Universitas 'Aisyiyah Yogyakarta",
          year: '2019',
          description:
            'Meraih juara 2 untuk kelas D Putra dalam lomba Pencak Silat tingkat kota Jakarta Barat.',
          proofImages: ['/assets/Awards/Restu Agil Yuli Arjun-Sertifikat Juara 2 Pencak Silat.jpg'],
        },
      ],
    },
    education: {
      subtitle: '// tempat saya belajar',
      title: '',
      titleHighlight: 'Pendidikan',
      university: "Universitas 'Aisyiyah Yogyakarta",
      universityUrl: 'https://www.unisayogya.ac.id/',
      accreditationLabel: 'Akreditasi Kampus',
      accreditationValue: 'Unggul',
      degree: 'S1 Teknologi Informasi (Bachelor of Computer Science)',
      stats: [
        { value: '3.91', label: 'IPK / 4.00' },
        { value: '2021', label: 'Tahun Masuk' },
        { value: '2025', label: 'Lulus' },
        { value: '7', label: 'Semester' },
      ],
      activitiesTitle: 'Kegiatan Akademik & Kampus',
      activities: [
        {
          title: 'Asisten Peneliti PhD - UNISA Yogyakarta',
          period: 'Agt - Okt 2024',
          desc: "Membantu kegiatan penelitian doktoral di Universitas 'Aisyiyah Yogyakarta, berkontribusi dalam pengumpulan data, analisis, dan dokumentasi akademik.",
        },
        {
          title: 'Pertukaran Mahasiswa - Kampus Merdeka (Universitas Bandar Lampung)',
          period: 'Sep - Des 2023',
          desc: 'Mengikuti program Pertukaran Mahasiswa Merdeka Kemdikbud. Merasakan budaya akademik yang berbeda dan memperluas jaringan profesional.',
        },
        {
          title: 'Anggota Organisasi & Kepanitiaan Aktif',
          period: '2020 - 2024',
          desc: 'Berpartisipasi dalam berbagai organisasi kampus, seminar, dan acara teknologi selama masa perkuliahan.',
        },
      ],
      works: {
        title: 'Publikasi Paper & Hak Paten',
        publicationsTitle: 'Publikasi Paper',
        patentsTitle: 'Hak Kekayaan Intelektual (HKI) / Paten',
        previewButton: 'Preview PDF',
        openJournal: 'Buka link jurnal',
        openDocument: 'Cek paten',
        patentNumber: 'No. Hak Cipta',
        patentStatus: 'Status',
        close: 'Tutup preview',
        previewTag: 'Preview Paper',
        previewUnavailable: 'Preview PDF belum tersedia untuk link ini. Silakan buka link jurnal langsung.',
        publications: [
          {
            title: 'Deteksi Bahan Pangan Tinggi Protein Menggunakan Model You Only Look Once (YOLO)',
            journal: 'Building of Informatics, Technology and Science (BITS) Journal',
            year: '2025',
            authors: 'Restu Agil Yuli Arjun, Esi Putri Silmina.',
            description:
              'Penelitian deteksi bahan MP-ASI berbasis computer vision untuk mendukung intervensi gizi anak secara lebih cepat dan akurat.',
            journalUrl: 'https://ejurnal.seminar-id.com/index.php/bits/article/view/6889/3563',
          },
          {
            title: 'Pemanfaatan Model YOLOv8 untuk Mendeteksi Plat Nomor Kendaraan Mobil pada Gerbang Masuk Universitas XYZ',
            journal: 'Jurnal Sains dan Informatika',
            year: '2025',
            authors: 'Esi Putri Silmina, Restu Agil Yuli Arjun.',
            description:
              'Penelitian deteksi plat nomor kendaraan menggunakan YOLOv8 untuk meningkatkan keamanan dan efisiensi di gerbang masuk kampus.',
            journalUrl: 'https://jsi.politala.ac.id/index.php/JSI/article/view/916/212',
          },
        ],
        patents: [
          {
            title: 'SIMANIS (Deteksi Menu Makanan Pendamping ASI)',
            institution: 'Direktorat Jenderal Kekayaan Intelektual',
            year: '2024',
            patentNumber: 'EC002024193259',
            status: 'Terdaftar',
            description:
              'Inovasi sistem pendukung identifikasi bahan MP-ASI berbasis AI untuk membantu pemantauan gizi pada layanan kesehatan.',
            referenceUrl: 'https://pdki-indonesia.dgip.go.id/detail/e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855',
          },
          {
            title: 'Penerapan Algoritma Genetika untuk Penentuan Menu Makanan Terbaik dan Terburuk',
            institution: 'Direktorat Jenderal Kekayaan Intelektual',
            year: '2023',
            patentNumber: 'EC00202366511',
            status: 'Terdaftar',
            description:
              'Inovasi metode penentuan menu makanan terbaik dan terburuk menggunakan algoritma genetika untuk mendukung pengambilan keputusan dalam perencanaan gizi.',
            referenceUrl: 'https://pdki-indonesia.dgip.go.id/detail/e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855',
          },
          {
            title: 'Aplikasi Inventaris Obat',
            institution: 'Direktorat Jenderal Kekayaan Intelektual',
            year: '2023',
            patentNumber: 'EC00202317030',
            status: 'Terdaftar',
            description:
              'Inovasi aplikasi inventaris obat berbasis AI untuk meningkatkan efisiensi manajemen stok dan distribusi obat di fasilitas kesehatan.',
            referenceUrl: 'https://pdki-indonesia.dgip.go.id/detail/e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855',
          },
        ],
        emptyPublications: 'Belum ada data publikasi.',
        emptyPatents: 'Belum ada data hak paten.',
      },
    },
    contact: {
      subtitle: '// mari terhubung',
      title: 'Hubungi',
      titleHighlight: 'Saya',
      description:
        'Tertarik bekerja sama? Jangan ragu untuk menghubungi saya. Saya selalu terbuka untuk mendiskusikan proyek baru, ide kreatif, atau kesempatan untuk menjadi bagian dari visi Anda.',
      email: 'Email',
      phone: 'Telepon',
      location: 'Lokasi',
      ctaTitle: 'Mari bekerja',
      ctaTitleHighlight: 'sama',
      ctaDesc:
        'Apakah Anda membutuhkan bantuan dalam administrasi database, proyek AI/ML, atau solusi computer vision, saya siap berkolaborasi dan mewujudkan ide Anda.',
      sendEmail: 'Kirim Email',
      downloadCV: 'Unduh CV Saya',
      footer: {
        by: 'Restu Agil Yuli Arjun',
        rights: 'Hak cipta dilindungi.',
      },
    },
  },
};
